<template>
    <div>
        <canvas :ref="'qrCanvas' + index"></canvas>
    </div>
</template>

<script>
    import QRCode from 'qrcode'

    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        mounted() {
            this.generateQRCode(this.text, this.$refs['qrCanvas' + this.index])
        },
        methods: {
            generateQRCode(text, canvas) {
                QRCode.toCanvas(canvas, text, error => {
                    if (error) console.error(error)
                })
            }
        }
    }
</script>

<style scoped>
    canvas{
        width: 42px !important;
        height: 42px !important;
    }
</style>